<template>
  <button
    v-if="isButton"
    type="button"
    class="link-with-icon"
    @click="onClickFunction"
  >
    <i
      v-if="icon"
      :class="icon"
      class="link-with-icon__icon"
    />
    {{ text }}
  </button>
  <a
    v-else
    :href="href"
    class="link-with-icon"
  >
    <i
      v-if="icon"
      :class="icon"
      class="link-with-icon__icon"
    />
    {{ text }}
  </a>
</template>

<script setup lang="ts">
import {
  computed,
} from 'vue';

type TCallback = () => any;

const props = defineProps<{
  text: string,
  /**
   * Either the onClick action to be executed if clicked, or the link to be opened.
   */
  onClick: string | TCallback,
  icon?: string,
}>();

const isButton = computed<boolean>(() => typeof props.onClick === 'function');
const href = computed<string | undefined>(() => {
  if (typeof props.onClick === 'string') {
    return props.onClick;
  }
  return undefined;
});
const onClickFunction = computed<TCallback | undefined>(() => {
  if (typeof props.onClick === 'function') {
    return props.onClick;
  }
  return undefined;
});
</script>

<style scoped lang="scss">
.link-with-icon {
  cursor: pointer;
  text-decoration: underline;
  flex-grow: 0;

  &__icon {
    &.pi::before {
      text-decoration: underline;
    }
  }
}
</style>
